var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-university"},[_c('BreadCrumb',{attrs:{"data":_vm.breadcrumb,"title":'院校列表管理'}}),_vm._v(" "),_c('StatisticalPanel',{attrs:{"whichModule":'universities',"data":_vm.overallData}}),_vm._v(" "),_c('div',{staticClass:"pc-university-table"},[_c('UniversityTable')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a490ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/university/UniversityList.vue
// module id = SNKe
// module chunks = 0